import React from "react";
import { UpdateOptions } from "../CreateUpdatePage";
import { Form } from "react-bootstrap";

interface UpdateOptionsComponentProps {
  options: UpdateOptions;
  onOptionsChanged: (options: UpdateOptions) => void;
}

function UpdateOptionsComponent({
  options,
  onOptionsChanged,
}: UpdateOptionsComponentProps) {
  return (
    <div>
      <p>The release process can be customized with the following options:</p>
      <Form.Check
        type="checkbox"
        id="updateprocess-options-skipexisting"
        label="Skip existing .mpfz files"
        defaultChecked={options.skipExistingMpfzFiles}
        onChange={(e) =>
          onOptionsChanged({
            ...options,
            skipExistingMpfzFiles: e.target.checked,
          })
        }
      />
      <Form.Text>
        Enabling this option will skip files that were generated since last time
        release was created. It can be used to avoid having to process all files
        again in case something went wrong in a previous release attempt.
      </Form.Text>
    </div>
  );
}

export default UpdateOptionsComponent;
